import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { EyeIcon, TrashIcon, XMarkIcon, ArrowPathIcon } from "@heroicons/vue/24/outline";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    editBtn: {
        type: Boolean,
    },
    deleteBtn: {
        type: Boolean,
    },
    closeBtn: {
        type: Boolean,
    },
    restoreBtn: {
        type: Boolean,
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["mx-1 inline-flex items-center p-1 border border-transparent rounded-full text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1", [__props.deleteBtn ? 'focus:ring-red-400' : 'focus:ring-blue-400']])
  }, [
    (__props.editBtn)
      ? (_openBlock(), _createBlock(_unref(EyeIcon), {
          key: 0,
          class: "p-0.5 h-6 w-6 text-gray-500"
        }))
      : (__props.closeBtn)
        ? (_openBlock(), _createBlock(_unref(XMarkIcon), {
            key: 1,
            class: "p-0.5 h-6 w-6 text-gray-500"
          }))
        : (__props.deleteBtn)
          ? (_openBlock(), _createBlock(_unref(TrashIcon), {
              key: 2,
              class: "p-0.5 h-6 w-6 text-red-500"
            }))
          : (__props.restoreBtn)
            ? (_openBlock(), _createBlock(_unref(ArrowPathIcon), {
                key: 3,
                class: "p-0.5 h-6 w-6 text-green-500"
              }))
            : _createCommentVNode("", true)
  ], 2))
}
}

})